import { render, staticRenderFns } from "./ArticleExcerpt.vue?vue&type=template&id=7a408309&"
import script from "./ArticleExcerpt.vue?vue&type=script&lang=js&"
export * from "./ArticleExcerpt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/buddy/magculture/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a408309')) {
      api.createRecord('7a408309', component.options)
    } else {
      api.reload('7a408309', component.options)
    }
    module.hot.accept("./ArticleExcerpt.vue?vue&type=template&id=7a408309&", function () {
      api.rerender('7a408309', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/DynamicTabs/ArticleExcerpt.vue"
export default component.exports